module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_6000.7619474d.png";